import React from 'react';
import { useSelector } from 'react-redux';

import { selectIsMarketplaceBlocked } from '../../store/selectors/init';
import UsOnlyScreen from '../UsOnly/UsOnlyScreen';
import PickYourGift from './PickYourGift';

const PickYourGiftRoute = () => {
  const isMarketplaceBlocked = useSelector(selectIsMarketplaceBlocked);

  return isMarketplaceBlocked ? <UsOnlyScreen /> : <PickYourGift />;
};

export default PickYourGiftRoute;
